import {CopilotIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'

import {copilotChatPanelID} from '../utils/constants'
import {useChatState} from '../utils/CopilotChatContext'
import {useChatManager} from '../utils/CopilotChatManagerContext'
import {getSelectedThread} from '../utils/get-selected-thread'
import styles from './FloatingButton.module.css'

const FloatingButton = () => {
  const state = useChatState()
  const manager = useChatManager()
  const thread = getSelectedThread(state)

  return (
    <IconButton
      // This is a floating button and should not be tabbable.
      // It should be accessible via the floating button hotkey.
      // Keyboard navigation is supported for the static button in the header.
      tabIndex={-1}
      id="copilot-floating-button"
      icon={CopilotIcon}
      aria-label="Open Copilot chat"
      aria-controls={copilotChatPanelID}
      tooltipDirection="w"
      onClick={() => {
        void manager.openChat(thread, state.currentView, 'floating-button-v2', state.chatVisibleSettingPath)
      }}
      data-hotkey="Shift+Z"
      className={styles.FloatingButtonContainer}
    />
  )
}

export default FloatingButton

try{ FloatingButton.displayName ||= 'FloatingButton' } catch {}